export default "__VITE_ASSET__I8Xu4NSb__"